// extracted by mini-css-extract-plugin
export var container = "_4w-0";
export var error = "_4w-9";
export var label = "_4w-5";
export var light = "_4w-6";
export var md = "_4w-3";
export var sm = "_4w-2";
export var thin = "_4w-8";
export var thinBold = "_4w-7";
export var vertical = "_4w-4";
export var xs = "_4w-1";